import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class SlideOutPanelService {
  private readonly isSlideOutOpen$$ = new BehaviorSubject<boolean>(false);
  public readonly isSlideOutOpen$ = this.isSlideOutOpen$$.asObservable();

  openSlideOut(): void {
    this.isSlideOutOpen$$.next(true);
  }

  closeSlideOut(): void {
    this.isSlideOutOpen$$.next(false);
  }
}
